import React, { useState, useContext, useEffect } from "react";
import $ from "jquery";

import "antd/dist/antd.css";
import { connect } from "react-redux";
import {
  Edit,
  AllInclusive,
  Storage,
  ReportProblem,
  AccountTree,
  Cancel,
  UnfoldLess,
  UnfoldMore,
  ExpandMore,
} from "@material-ui/icons";
import { Button, Modal, Switch, Tooltip } from "antd";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { v4 as uuid } from "uuid";
import settingIcon from "../../../../../images/branching/setting-icon.svg";
import recordIcon from "../../../../../images/branching/record.svg";
import assertIcon from "../../../../../images/branching/assert.svg";
import waitIcon from "../../../../../images/branching/wait.svg";
import stopIcon from "../../../../../images/branching/stop.svg";
import branchIcon from "../../../../../images/branching/branching.svg";
import imageIcon from "../../../../../images/image-pic.png";
import playWhite from "../../../../../images/play-white.png";

import readIcon from "../../../../../images/branching/readIcon.png";
import filesandfolders from "../../../../../images/branching/files.png";
import outlookIcon from "../../../../../images/branching/outlook-icon.png";
import outlookImage from "../../../../../images/branching/outlook-image.png";
import webAutomationIcon from "../../../../../images/template-img/web-automation.png";
import automationIcon from "../../../../../images/template-img/automation-icon.png";
import folderIcon from "../../../../../images/template-img/MIS.png";
import assign from "../../../../../images/assign.png";
import httpApi from "../../../../../images/httpApi.png";
import httpApiIcon from "../../../../../images/httpApiIcon.png";
import assignIcon from "../../../../../images/assignIcon.png";
import InvokeSkillIcon from "../../../../../images/InvokeSkillIcon.png";
import InvokeSkillImg from "../../../../../images/InvokeSkillImg.png";
import todoIcon from "../../../../../images/todo-icon.png";
import excelIcon from "../../../../../images/excel-action.png";
import automation from "../../../../../images/template-img/data-loading.png";
import echoIcon from "../../../../../images/branching/echoIcon.png";
import messageBoxIcon from "../../../../../images/branching/messageBoxIcon.png";
import reviewIcon from "../../../../../images/branching/review-icon.png";
import echoImage from "../../../../../images/branching/echo-image.png";
import messageBoxImage from "../../../../../images/branching/messageBox-image.png";
import kbdIcon from "../../../../../images/kbdIcon.png";
import kpIcon from "../../../../../images/kpIcon.png";
import javascriptImage from "../../../../../images/branching/javascriptImage.png";
import javascriptIcon from "../../../../../images/branching/javascriptIcon.png";
import imgEditIcon from "../../../../../images/edit-white.svg";
import breakIcon from "../../../../../images/break.png";
import continueIcon from "../../../../../images/continue.png";
import openAppIcon from "../../../../../images/branching/open-app.svg";
import openAppImage from "../../../../../images/branching/open-app-ill.svg";
import closeAppIcon from "../../../../../images/branching/close-app.svg";
import closeAppImage from "../../../../../images/branching/close-app-ill.svg";
import switchAppIcon from "../../../../../images/branching/switch-app.svg";
import switchAppImage from "../../../../../images/branching/switch-app-ill.svg";
import s3FileDownloadIcon from "../../../../../images/s3-file-download.png";
import s3ConnectIcon from "../../../../../images/s3-connect.png";
import s3Download from "../../../../../images/s3-file-download-illustration.png";
import s3Connect from "../../../../../images/AWS-S3-Connect.png";
import s3Archive from "../../../../../images/s3-archive-illustration.png";
import s3ArchiveIcon from "../../../../../images/s3-archive.png";
import readCred from "../../../../../images/read-illustration.png";
import readCredIcon from "../../../../../images/read-icon.svg";
import readTable from "../../../../../images/table-illustration.png";
import readTableIcon from "../../../../../images/table-icon.png";
import keyboardshortCutIcon from "../../../../../images/keyboard-shortcut.png";
import keyboardshortCut from "../../../../../images/keyboard-illustration.png";
import closeFileIcon from "../../../../../images/closefile-icon.png";
import closeFile from "../../../../../images/closefile-illustration.png";
import skillSetImage from "../../../../../images/SkillsetImage.png";
import skillSetIcon from "../../../../../images/SkillsetIcon.png";
import smtpIcon from "../../../../../images/smtp-icon.png";
import smtpImage from "../../../../../images/smtp-image.png";
import clipboardImg from "../../../../../images/clipboard-illustration.svg";
import clipboardIcon from "../../../../../images/clipboard-Icon.svg";
import dataExtactionIcon from "../../../../../images/data-extraction.svg";
import dataExtactionImg from "../../../../../images/data-extractionImg.svg";
import approvedIcon from "../../../../../images/Approved.png";
import rejectedIcon from "../../../../../images/Rejected.png";
import approveActionIcon from "../../../../../images/approval-action-img.png";
import xmlIcon from "../../../../../images/xml-icon.png";
import xmlIllustration from "../../../../../images/xml-illustration.png";
import dbIcon from "../../../../../images/db-icon.png";
import dbIllustration from "../../../../../images/db-illustration.png";
import hoverIcon from "../../../../../images/hover-icon.png";
import hoverIllustration from "../../../../../images/hover-illustration.png";

import settingIconFx from "../../../../../images/training/settings-icon.png";
import logsIconFx from "../../../../../images/training/logs-icon.png";
import startIconFx from "../../../../../images/training/started-icon.png";
import screenShotImg from "../../../../../images/training/Screenshot-Illustration.png";
import screenShotIcon from "../../../../../images/training/Screenshot-Img .png";
import gptIcon from "../../../../../images/ChatGPT_Icon.png";
import gptImage from "../../../../../images/ChatGPT_Illustration.png";
import ThrowAction_Icon from "../../../../../images/Throw Action_Icon.png";
import ThrowAction_Illustration from "../../../../../images/Throw Action_Illustration.png";
import arrowDownStart from "../../../../../images/arrow-down-start.svg";

import Zoom from "react-medium-image-zoom";
// import Blur from 'react-blur'

import _ from "lodash";

import { Select, Drawer } from "antd";

import FlowBuilder, {
  NodeContext,
  BuilderContext,
  buildFlatNodes,
  buildTreeNodes,
  useAction,
} from "react-flow-builder";

import { useHistory } from "react-router-dom";
import Loader from "../../../../../components/loader";
import { useInView } from "react-intersection-observer";
const { Option } = Select;

const DisplayFlowNodes = (props) => {
  const flow = props?.document?.actions;
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const [nodes, setNodes] = useState([]);

  const [customClassName, setCustomClassName] = useState("");
  const [showPanel, setShowPanel] = useState(false);

  const [loader, setLoader] = useState(false);
  let [validNodes, setValidNodes] = useState([]);
  const [currentNode, setCurrentNode] = useState();

  const loading = useSelector((state) => state.skillReducer.loading);
  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrgUser
  );
  const userSub = useSelector((state) => state.userReducer?.user?.sub);
  const userEmail = useSelector((state) => state.userReducer?.user?.email);
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);

  const openStepPanel = (currentNode) => {
    setShowPanel(true);
    setCurrentNode(currentNode);
  };
  const handleOk = () => {
    setShowPanel(false);
    setCurrentNode({});
  };

  const handleCancel = () => {
    setShowPanel(false);
    setCurrentNode({});
  };

  const getNode = (type, child = false) => {
    return {
      id: uuid(),
      type: type,
      name: type,
      actionType: type,
      children: child ? [] : undefined,
      isStart: type === "start",
      isEnd: type === "end",
    };
  };
  const getRearrangedData = (actions) => {
    let temp = [];
    temp.push(getNode("start"));
    actions.forEach((a, i) => {
      if (!a.type) {
        a.type = a.actionType;
        temp.push(a);
      } else {
        temp.push(a);
      }
    });
    temp.push(getNode("end"));
    return temp;
  };
  useEffect(() => {
    setValidNodes(registerNodes);
    let _actions = _.cloneDeep(props?.document?.actions);

    let actions = getRearrangedData(_actions || []);
    setNodes(actions);
  }, [props?.id]);

  const minimize = (id) => {
    let parent = $(`#${id}`).closest(".try-catch-node")[0];
    $(parent)
      .find(".flow-builder-line__split ")
      .each(function (i, e) {
        $(this).show(500);
      });
    $(parent)
      .find(".flow-builder-action-button")
      .each(function (i, e) {
        $(this).slideToggle(500);
      });

    $(parent)
      .find(".flow-builder-node")
      .each(function (i, e) {
        $(this).slideToggle(500);
      });

    $(parent)
      .find(".mui-icon svg")
      .each(function (i, e) {
        $(this).toggleClass("upDown-rotate");
      });
  };

  const GetSkillLabel = (node) => {
    const readOnly = useSelector((state) => state.skillReducer?.readOnly);

    return (
      <div className="rth-tooltip">
        <div className="flex-rth-title">
          <p> Label: </p>
          {readOnly == false ? (
            <Edit
              onClick={(e) => {
                $(`#${node.id}`).toggle();
                e.stopPropagation();
              }}
            />
          ) : null}
        </div>
        <span style={{ fontSize: 12, fontWeight: "400" }}>
          {node.description}
        </span>
        <div
          id={`${node.id}`}
          style={{ display: "none" }}
          className="rth-tooltip"
        >
          <textarea
            rows="1"
            maxlength="50"
            placeholder="Type Something..."
            defaultValue={node.description}
          ></textarea>
        </div>
      </div>
    );
  };

  const LoopStartDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div>
        <div className={`stop-node delay-node rt-block-full`}>
          {/* <span style={{ fontSize: 12, fontWeight: 'bold' }}> Description: </span> */}
          <div className="delay-flex">
            <div
              className="stepIconBlock"
              style={{ backgroundColor: "#eff1ff", borderColor: "#9f64ff" }}
            >
              <AllInclusive style={{ color: "#9f64ff" }} />
            </div>
            <div className="delay-text">
              <h4 className="node-titles">Loop start</h4>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ReviewTaskNodeDisplay = () => {
    const node = useContext(NodeContext);
    let { rootNodes } = useContext(BuilderContext);
    const readOnly = useSelector((state) => state.skillReducer?.readOnly);

    const { removeNode } = useAction();
    const linkedCallbackNode = node.id.replace("node-start-", "");
    const _removeChild = (ids) => {
      ids.forEach((i) => {
        removeNode(i);
      });
    };
    return (
      <div>
        {node.name == "review-node-start" ? (
          <div className="review-container">
            <Cancel
              className="cancel-button-icon"
              style={{
                color: "#FF6343",
                width: 18,
                height: 18,
                backgroundColor: "white",
                borderRadius: "50%",
              }}
              onClick={() => _removeChild([node.id, linkedCallbackNode])}
            />
            {/* Approval action 1 */}
            <div className="aprove-action-block">
              {/* <h3>Review</h3> */}
              <div className={`delay-node rt-block-full`}>
                <div className="rt-block-header">
                  <div className="rth-title">
                    <div className="tl-cont flex-irt">
                      <div
                        className="tl-cont-ico"
                        // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
                        style={{
                          padding: "0px",
                          borderRadius: "0px",
                          border: "none",
                        }}
                      >
                        <img
                          src={reviewIcon}
                          // style={{ width: "12px" }}
                        />
                      </div>
                      <div className="rth-tl-tp">
                        <p>Review</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="rth-tooltip">
                  <div className="flex-rth-title">
                    <p> Label: </p>
                    {readOnly == false ? (
                      <Edit
                        onClick={(e) => {
                          $(`#${node.id}`).toggle();
                          e.stopPropagation();
                        }}
                      />
                    ) : null}
                  </div>
                  <span style={{ fontSize: 12, fontWeight: "400" }}>
                    {node.description}
                  </span>
                  <div
                    id={`${node.id}`}
                    style={{ display: "none" }}
                    className="rth-tooltip"
                  >
                    <textarea
                      rows="1"
                      maxlength="50"
                      placeholder="Type Something..."
                      defaultValue={node.description}
                    ></textarea>
                  </div>
                </div>

                <div className="rtb-screenshot filled-bg">
                  <img src={approveActionIcon} alt="pageScreenshot" />
                </div>
              </div>
              {/* <img src={approveActionIcon} /> */}
            </div>
          </div>
        ) : (
          <div>
            <div
              className={`app-review-action review-node-action-${node.name.toLowerCase()}`}
            >
              {/* {node.name} */}
              {node.name === "Approve" ? (
                <img src={approvedIcon} />
              ) : (
                <img src={rejectedIcon} />
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const TryCatchDisplay = () => {
    const node = useContext(NodeContext);
    let { rootNodes } = useContext(BuilderContext);

    const { removeNode } = useAction();
    return (
      <div className="try-catch-container" id={node.id}>
        {!rootNodes?.includes(node.id) ? (
          <Cancel
            className="cancel-button-icon"
            style={{ color: "#FF6343", width: 18, height: 18 }}
            onClick={() => removeNode(node.id)}
          />
        ) : null}
        {node.name == "Error Handle" ? (
          <div className={`stop-node delay-node rt-block-full`}>
            <div className="delay-flex">
              <div
                className="stepIconBlock"
                style={{ backgroundColor: "#f4c6c6", borderColor: "#ff0000" }}
              >
                {node.name == "Error Handle" ? (
                  <ReportProblem style={{ color: "#ff0000" }} />
                ) : null}
              </div>

              <div className="delay-text">
                {/* <button onClick={() => expand(node.id)}> <UnfoldMore /></button> */}
                <h4 className="node-titles">{node.name}</h4>
                <button className="mui-icon" onClick={() => minimize(node.id)}>
                  <ExpandMore />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={`stop-node delay-node rt-block-full`}>
            <div className="delay-flex">
              <div
                className="stepIconBlock"
                style={{ backgroundColor: "#deeffc", borderColor: "#3fa9ff" }}
              >
                <AccountTree style={{ color: "#3fa9ff" }} />
              </div>

              <div className="delay-text">
                {/* <button onClick={() => expand(node.id)}> <UnfoldMore /></button> */}
                <h4 className="node-titles">{node.name}</h4>
                <button className="mui-icon" onClick={() => minimize(node.id)}>
                  <ExpandMore />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const AddDataSetNode = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#00CD9D", backgroundColor: "#b2f7e6" }}
              >
                <Storage
                  style={{
                    width: "12px",
                    borderColor: "#00CD9D",
                    backgroundColor: "#b2f7e6",
                    color: "#00CD9D",
                  }}
                />
              </div>
              <div className="rth-tl-tp">
                <p>Dataset</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={folderIcon} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const AddS3Node = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
              >
                <img style={{ width: "12px" }} src={s3ConnectIcon} alt="" />
              </div>
              <div className="rth-tl-tp">
                <p>S3 Connect</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={s3Connect} alt="pageScreenshot" />
        </div>
      </div>
    );
  };
  // const AddSMTPNode = () => {
  //   const node = useContext(NodeContext);
  //   return (
  //     <div className={`delay-node rt-block-full`}>
  //       <div className="rt-block-header">
  //         <div className="rth-title">
  //           <div className="tl-cont flex-irt">
  //             <div
  //               className="tl-cont-ico"
  //               style={{ padding: "0px", borderRadius: "0px", border: "none" }}
  //             >
  //               <img src={smtpIcon} />
  //             </div>
  //             <div className="rth-tl-tp">
  //               <p>SMTP Send Mail</p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       {GetSkillLabel(node)}
  //       <div className="rtb-screenshot filled-bg">
  //         <img src={smtpImage} alt="pageScreenshot" />
  //       </div>
  //     </div>
  //   );
  // };

  const AddS3ArchiveNode = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#173bff", backgroundColor: "#eff1ff" }}
              >
                <img style={{ width: "12px" }} src={s3ArchiveIcon} alt="" />
              </div>
              <div className="rth-tl-tp">
                <p>S3 Archive</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={s3Archive} alt="pageScreenshot" />
        </div>
      </div>
    );
  };
  const AddS3DownloadNode = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#1d262e", backgroundColor: "#ebebeb" }}
              >
                <img
                  style={{ width: "12px" }}
                  src={s3FileDownloadIcon}
                  alt=""
                />
              </div>
              <div className="rth-tl-tp">
                <p>S3 File Download</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={s3Download} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const ReadCredentialsNode = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
              >
                <img style={{ width: "12px" }} src={readCredIcon} alt="" />
              </div>
              <div className="rth-tl-tp">
                <p>Read Credentials</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={readCred} alt="pageScreenshot" />
        </div>
      </div>
    );
  };
  const StartNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className="start-node">
        <></>
        <span className="flow-emailer">{props?.["organization.email"]}</span>
        <span className="flow-id">Variant Id: {props?.revision}</span>

        <div className="rt-block rt-start">
          <div
            className="rtb-ico"
            style={{
              backgroundColor: "#02ce9d",
              cursor: "default",
            }}
          >
            <img src={arrowDownStart} alt="" />
          </div>
          <div className="rtb-text">
            <p>Start</p>
          </div>
        </div>
      </div>
    );
  };

  const EndNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className="end-node">
        <div className="rt-block rt-end">
          <div
            className="rtb-ico"
            style={{
              backgroundColor: "#ff3333",
              cursor: "default",
            }}
          >
            <span className="circle"></span>
          </div>
          <div className="rtb-text">
            <p>End</p>
          </div>
        </div>
      </div>
    );
  };

  const NodeDisplay = () => {
    const { ref, inView, entry } = useInView({
      /* Optional options */
      threshold: 0,
    });
    const node = useContext(NodeContext);
    const { skillTemplate, skillType } = useContext(BuilderContext);
    const [selectedImage, setSelectedImage] = useState("");
    const userRole = useSelector(
      (state) => state.organizationReducer?.currentOrgUser
    );

    const [loadingMaskedImage, setLoadingMaskedImage] = useState(false);
    return (
      <>
        {node.name === "show" || node.name === "train" ? (
          <div className="rt-block-full recording-block">
            <div className="rcd-icon">
              <img src={recordIcon} />
            </div>
            <div className="rcd-text">
              <h4>Show</h4>
              <p> Click on Start button to initiate Web/Desktop show process</p>
              <div className="rth-tooltip">
                {node.description ? (
                  <span style={{ fontSize: 12, fontWeight: "400" }}>
                    {node.description}
                  </span>
                ) : null}{" "}
              </div>
            </div>
          </div>
        ) : (
          <div
            className={`rt-block-full other-node ${
              node.configuring ? "node-configuring" : ""
            } ${node.validateStatusError ? "node-status-error" : ""}`}
          >
            <div className="rth-title">
              <div className="tl-cont">
                <div className="rth-tooltip">
                  <span style={{ fontSize: 12, fontWeight: "400" }}>
                    {node.description}
                  </span>
                  <div
                    id={`${node.id}`}
                    style={{ display: "none" }}
                    className="rth-tooltip"
                  >
                    <textarea
                      rows="1"
                      placeholder="Type Something..."
                      defaultValue={node.description}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            {node.actionType == "kbd_shortcut" ||
            node.actionType == "kp" ||
            node.actionType == "kbd" ? null : (
              <div className="rtb-screenshot" ref={ref}>
                {node.image ? (
                  <>
                    {inView ? (
                      <div className="img-preview-thumb">
                        <img src={node.image} />
                      </div>
                    ) : null}
                  </>
                ) : null}
                {inView ? (
                  <Zoom>
                    <img src={node.pageScreenshot} alt="pageScreenshot" />
                  </Zoom>
                ) : null}
              </div>
            )}

            <span className="setting-icon" onClick={() => openStepPanel(node)}>
              <img src={settingIcon} />
            </span>
          </div>
        )}
      </>
    );
  };

  const ConditionNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div
        className={`rt-block-full condition-node ${
          false ? "node-configuring" : ""
        } ${true ? "node-status-error" : ""}`}
      >
        <div className="rotate-content">
          <h4 className="node-titles">{node.name}</h4>
        </div>
      </div>
    );
  };

  const StopNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`stop-node rt-block-full`}>
        <div className="delay-flex">
          <div
            className="stepIconBlock"
            style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
          >
            <img src={stopIcon} />
          </div>
          <div className="delay-text">
            <h4 className="node-titles">{node.name}</h4>
          </div>
        </div>
      </div>
    );
  };

  const CloseTabNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`stop-node rt-block-full`}>
        <div className="delay-flex">
          <div
            className="stepIconBlock"
            style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
          >
            <img src={closeAppIcon} />
          </div>
          <div className="delay-text">
            <h4 className="node-titles">{node.name}</h4>
          </div>
        </div>
      </div>
    );
  };

  const AssertNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div
        className={`assert-block ${false ? "node-configuring" : ""} ${
          true ? "node-status-error" : ""
        }`}
      >
        <div className="rotate-content">
          <h4 className="node-titles">{node.name}</h4>
        </div>
      </div>
    );
  };

  const DelayNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`stop-node delay-node rt-block-full`}>
        {/* <span style={{ fontSize: 12, fontWeight: 'bold' }}> Description: </span> */}
        <div className="delay-flex">
          <div
            className="stepIconBlock"
            style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
          >
            <img src={waitIcon} />
          </div>
          <div className="delay-text">
            <h4 className="node-titles">{node.description}</h4>
            <Edit onClick={() => $(`#${node.id}`).toggle()} />
          </div>
        </div>
        <div
          id={`${node.id}`}
          style={{ display: "none", marginTop: 10 }}
          className="rth-tooltip"
        >
          <input defaultValue={node.time}></input>
        </div>
      </div>
    );
  };

  const BreakNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`stop-node delay-node rt-block-full`}>
        <div className="delay-flex">
          <div
            className="stepIconBlock"
            style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
          >
            <img src={breakIcon} />
          </div>
          <div className="delay-text">
            <h4 className="node-titles">{node.description}</h4>
          </div>
        </div>
        <div
          id={`${node.id}`}
          style={{ display: "none", marginTop: 10 }}
          className="rth-tooltip"
        ></div>
      </div>
    );
  };

  const ContinueNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`stop-node delay-node rt-block-full`}>
        <div className="delay-flex">
          <div
            className="stepIconBlock"
            style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
          >
            <img src={continueIcon} />
          </div>
          <div className="delay-text">
            <h4 className="node-titles">{node.description}</h4>
          </div>
        </div>
        <div
          id={`${node.id}`}
          style={{ display: "none", marginTop: 10 }}
          className="rth-tooltip"
        ></div>
      </div>
    );
  };

  const ClipboradNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`stop-node rt-block-full`}>
        <div className="delay-flex">
          <div
            className="stepIconBlock"
            style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
          >
            <img src={closeAppIcon} />
          </div>
          <div className="delay-text">
            <h4 className="node-titles">{node.name}</h4>
          </div>
        </div>
      </div>
    );
  };

  const ReadValueNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div className="tl-cont-ico" style={{ borderColor: "#411bbe" }}>
                <img src={readIcon} style={{ width: "14px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Read</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img
            src={automationIcon}
            alt="pageScreenshot"
            style={{ width: "70%" }}
          />
        </div>
      </div>
    );
  };

  const MailIntegrationNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div className="tl-cont-ico">
                <img src={outlookIcon} style={{ width: "30px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Outlook Mail</p>
              </div>
            </div>
          </div>
        </div>

        {GetSkillLabel(node)}

        <div className="rtb-screenshot filled-bg">
          <img src={outlookImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const FilesNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
              >
                <img src={filesandfolders} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Files / Folders</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={folderIcon} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const SecretNodeDisplay = () => {
    const node = useContext(NodeContext);
    return <div>{null}</div>;
  };

  const ExcelNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
              >
                <img src={excelIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Excel Actions</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={automation} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const SupervityOCRNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
              >
                <img
                  src={dataExtactionIcon}
                  style={{ width: "12px", maxWidth: "initial" }}
                />{" "}
              </div>
              <div className="rth-tl-tp">
                <p>Supervity OCR</p>
              </div>
            </div>
          </div>
        </div>

        {GetSkillLabel(node)}

        <div className="rtb-screenshot filled-bg">
          <img
            src={dataExtactionImg}
            alt="pageScreenshot"
            style={{ "max-width": "75%" }}
          />
        </div>
      </div>
    );
  };
  const HttpApiNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
              >
                <img src={httpApi} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Service Call</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={httpApiIcon} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const EchoNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img
                  src={echoIcon}
                  // style={{ width: "12px" }}
                />
              </div>
              <div className="rth-tl-tp">
                <p>Echo</p>
              </div>
            </div>
          </div>
        </div>

        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={echoImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const TechnologyNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#e6b921", backgroundColor: "#fff2c4" }}
                //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img src={javascriptIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Javascript</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={javascriptImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const OpenAppNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#9f64ff", backgroundColor: "#f2eaff" }}
                //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img src={openAppIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Open App</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={openAppImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const CloseAppNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
                //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img src={closeAppIcon} style={{ width: "10px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Close App</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={closeAppImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const SwitchAppNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#02b6ce", backgroundColor: "#edfdff" }}
                //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img src={switchAppIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Switch App</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={switchAppImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const MessageBoxNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img
                  src={messageBoxIcon}
                  // style={{ width: "12px" }}
                />
              </div>
              <div className="rth-tl-tp">
                <p>Message Box</p>
              </div>
            </div>
          </div>
        </div>

        {GetSkillLabel(node)}

        <div className="rtb-screenshot filled-bg">
          <img src={messageBoxImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const ClipboardNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                //style={{ backgroundColor: "#fff", borderColor: "#000"  }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img src={clipboardIcon} />
              </div>
              <div className="rth-tl-tp">
                <p>Clipboard</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={clipboardImg} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const AssignNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
              >
                <img src={assign} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Assign</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={assignIcon} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const InvokeSkillNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
              >
                <img src={InvokeSkillIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                {node?.skillName ? (
                  <p>{`Invoke Skill - ${node.skillName}`}</p>
                ) : (
                  <p>{`Invoke Skill`}</p>
                )}
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={InvokeSkillImg} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const AddSkillNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
              >
                <img src={skillSetIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                {node?.skillName ? (
                  <p>{`Add A Skill - ${node.skillName}`}</p>
                ) : (
                  <p>{`Add A Skill`}</p>
                )}
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={skillSetImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };
  const ToDoSkillNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
              >
                <img src={todoIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                {node?.skillName ? (
                  <p>{`To Do - ${node.skillName}`}</p>
                ) : (
                  <p>{`To Do`}</p>
                )}
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        {/* <div className="rtb-screenshot filled-bg">
        <img src={InvokeSkillImg} alt="pageScreenshot" />
      </div> */}
      </div>
    );
  };

  const ReadTableNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
              >
                <img src={readTableIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Read Table</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={readTable} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const HoverNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                // style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img src={hoverIcon} />
              </div>
              <div className="rth-tl-tp">
                <p>Hover</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={hoverIllustration} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const CloseFileNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
              >
                <img src={closeFileIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Close File</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={closeFile} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const KeyboardShortcutNodeDisplay = () => {
    const node = useContext(NodeContext);

    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ backgroundgColor: "#f2eaff", borderColor: "#9f64ff" }}
              >
                <img src={keyboardshortCutIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Keyboard ShortCuts</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={keyboardshortCut} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const CsvNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
              >
                <img src={excelIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>CSV Actions</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={automation} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const ScreenshotNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
              >
                <img src={screenShotIcon} style={{ width: "12px" }} />
              </div>
              <div className="rth-tl-tp">
                <p>Screenshot</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={screenShotImg} alt="pageScreenshot" />
        </div>
      </div>
    );
  };
  const XmlToJsonNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                // style={{ borderColor: "#e6b921", backgroundColor: "#fff2c4" }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img src={xmlIcon} />
              </div>
              <div className="rth-tl-tp">
                <p>XML To JSON</p>
              </div>
            </div>
          </div>
        </div>
        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={xmlIllustration} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const DBNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img
                  src={dbIcon}
                  // style={{ width: "12px" }}
                />
              </div>
              <div className="rth-tl-tp">
                <p>Database Action</p>
              </div>
            </div>
          </div>
        </div>

        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={dbIllustration} alt="pageScreenshot" />
        </div>
      </div>
    );
  };
  const ChatGptNodeDisplay = () => {
    const node = useContext(NodeContext);
    const dispatch = useDispatch();
    return (
      <div
        className={`delay-node rt-block-full`}
        //   onClick={() => openChatPanel(node.id)}
      >
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img
                  src={gptIcon}
                  // style={{ width: "12px" }}
                />
              </div>
              <div className="rth-tl-tp">
                <p>Generative AI</p>
              </div>
            </div>
          </div>
        </div>

        {GetSkillLabel(node)}
        <div className="rtb-screenshot filled-bg">
          <img src={gptImage} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  const ThrowNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className={`delay-node rt-block-full`}>
        <div className="rt-block-header">
          <div className="rth-title">
            <div className="tl-cont flex-irt">
              <div
                className="tl-cont-ico"
                // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
                style={{ padding: "0px", borderRadius: "0px", border: "none" }}
              >
                <img
                  src={ThrowAction_Icon}
                  // style={{ width: "12px" }}
                />
              </div>
              <div className="rth-tl-tp">
                <p>Throw Error</p>
              </div>
            </div>
          </div>
        </div>

        {GetSkillLabel(node)}

        <div className="rtb-screenshot filled-bg">
          <img src={ThrowAction_Illustration} alt="pageScreenshot" />
        </div>
      </div>
    );
  };

  let registerNodes = [
    {
      type: "start",
      name: "start",
      actionType: "start",
      displayComponent: StartNodeDisplay,
      isStart: true,
    },
    {
      type: "end",
      name: "end",
      actionType: "end",
      displayComponent: EndNodeDisplay,
      isEnd: true,
    },
    {
      type: "addSkillSet",
      name: "Add A Skill",
      actionType: "addSkillSet",
      displayComponent: AddSkillNodeDisplay,
      // configComponent: InvokeSkillConfigForm,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff", borderColor: "#000" }}
        >
          <img
            src={skillSetIcon}
            style={{ width: "12px", maxWidth: "initial" }}
          />
        </div>
      ),
    },
    {
      type: "toDoSkill",
      name: "Add a ToDo",
      actionType: "toDoSkill",
      displayComponent: ToDoSkillNodeDisplay,
      // configComponent: ToDoSkillConfigForm,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
        >
          <img src={todoIcon} style={{ width: "12px", maxWidth: "initial" }} />
        </div>
      ),
    },
    {
      type: "data-set",
      name: "Add Dataset",
      actionType: "addDataSet",
      displayComponent: AddDataSetNode,
      // configComponent: ConfigDataSet,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#b2f7e6", borderColor: "#00CD9D" }}
        >
          <Storage style={{ color: "#00CD9D" }} />
        </div>
      ),
    },
    {
      type: "assign",
      name: "Assign",
      actionType: "assign",
      displayComponent: AssignNodeDisplay,
      // configComponent: AssignConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
        >
          <img src={assign} />
        </div>
      ),
    },

    {
      type: "branch",
      name: "branch",
      actionType: "branch",
      // conditionNodeType: "condition",
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
        >
          <img src={branchIcon} />
        </div>
      ),
    },
    {
      type: "break",
      name: "break",
      actionType: "break",
      displayComponent: BreakNodeDisplay,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
        >
          <img src={breakIcon} />
        </div>
      ),
    },
    {
      type: "CHAT_GPT",
      name: "Generative AI",
      actionType: "CHAT_GPT",
      displayComponent: ChatGptNodeDisplay,
      // configComponent: ChatGptConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          //style={{ backgroundColor: "#fff", borderColor: "#000" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={gptIcon} />
        </div>
      ),
    },
    {
      type: "GET_CLIPBOARD",
      name: "Clipboard",
      actionType: "GET_CLIPBOARD",
      displayComponent: ClipboardNodeDisplay,
      // configComponent: ClipboardConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          //style={{ backgroundColor: "#fff", borderColor: "#000" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={clipboardIcon} />
        </div>
      ),
    },
    {
      type: "CLOSEAPP",
      name: "Close App",
      actionType: "CLOSEAPP",
      displayComponent: CloseAppNodeDisplay,
      // configComponent: CloseAppConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
          //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={closeAppIcon} style={{ width: "10px" }} />
        </div>
      ),
    },
    {
      type: "CLOSE",
      name: "Close File",
      actionType: "CLOSE",
      displayComponent: CloseFileNodeDisplay,
      // configComponent: CloseFileConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
        >
          <img src={closeFileIcon} />
        </div>
      ),
    },
    {
      type: "closetab",
      name: "Close Tab",
      displayComponent: CloseTabNodeDisplay,
      actionType: "closetab",
      configComponent: null,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
        >
          <img src={closeAppIcon} />
        </div>
      ),
    },
    {
      type: "continue",
      name: "continue",
      actionType: "continue",
      displayComponent: ContinueNodeDisplay,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
        >
          <img src={continueIcon} />
        </div>
      ),
    },
    {
      type: "CSV_HEADER",
      name: "CSV",
      actionType: "CSV_HEADER",
      displayComponent: CsvNodeDisplay,
      // configComponent: CsvConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
        >
          <img src={excelIcon} />
        </div>
      ),
    },

    {
      type: "dbConnection",
      name: "Database Action",
      actionType: "DB_CONNECTION",
      displayComponent: DBNodeDisplay,
      // configComponent: DBConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          // style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={dbIcon} />
        </div>
      ),
    },

    {
      type: "echo",
      name: "Echo",
      actionType: "ECHO",
      displayComponent: EchoNodeDisplay,
      // configComponent: EchoConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          // style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={echoIcon} />
        </div>
      ),
    },
    {
      type: "excel",
      name: "Excel",
      actionType: "OPEN_SPREADSHEET",
      displayComponent: ExcelNodeDisplay,
      // configComponent: ExcelConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
        >
          <img src={excelIcon} />
        </div>
      ),
    },
    {
      type: "filesandfolders",
      name: "Files/Folders",
      actionType: "readfile",
      displayComponent: FilesNodeDisplay,
      // configComponent: FilesFoldersConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
        >
          <img src={filesandfolders} />
        </div>
      ),
    },
    {
      type: "hover",
      name: "hover",
      actionType: "hover",
      displayComponent: HoverNodeDisplay,
      // configComponent: HoverConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          // style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={hoverIcon} />
        </div>
      ),
    },
    {
      type: "TECHNOLOGY",
      name: "Javascript",
      actionType: "TECHNOLOGY",
      displayComponent: TechnologyNodeDisplay,
      // configComponent: TechnologyConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
          //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={javascriptIcon} style={{ width: "12px" }} />
        </div>
      ),
    },
    {
      type: "KEY_STROKES",
      name: "Keyboard ShortCuts",
      actionType: "KEY_STROKES",
      displayComponent: KeyboardShortcutNodeDisplay,
      // configComponent: KeyboardShortcutConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundgColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <img src={keyboardshortCutIcon} />
        </div>
      ),
    },
    {
      type: "loop-nodes",
      name: "loop-nodes",
      displayComponent: LoopStartDisplay,
      actionType: "loopStart",
      // configComponent: LoopConfigPanel,
      // deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <AllInclusive style={{ color: "#9f64ff" }} />
        </div>
      ),
    },
    {
      type: "loop",
      name: "loop",
      conditionNodeType: "loop-nodes",
      actionType: "loop",
      addConditionIcon: null,
      configComponent: null,
      conditionMaxNum: 1,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <AllInclusive style={{ color: "#9f64ff" }} />
        </div>
      ),
    },
    {
      type: "messagebox",
      name: "Message Box",
      actionType: "MESSAGE_BOX",
      displayComponent: MessageBoxNodeDisplay,
      // configComponent: MessageBoxConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          // style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={messageBoxIcon} />
        </div>
      ),
    },
    {
      type: "OPENAPP",
      name: "Open App",
      actionType: "OPENAPP",
      displayComponent: OpenAppNodeDisplay,
      // configComponent: OpenAppConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
          //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={openAppIcon} style={{ width: "12px" }} />
        </div>
      ),
    },
    {
      type: "sendMail",
      name: "Outlook Mail",
      actionType: "sendMail",
      displayComponent: MailIntegrationNodeDisplay,
      // configComponent: SendMailConfigForm,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#deeef9", borderColor: "#0D75BB" }}
        >
          <img
            src={outlookIcon}
            style={{ width: "24px", maxWidth: "initial" }}
          />
        </div>
      ),
    },
    {
      type: "read",
      name: "read",
      actionType: "read",
      displayComponent: ReadValueNodeDisplay,
      // configComponent: ReadValueConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eff1ff", borderColor: "#411bbd" }}
        >
          <img src={readIcon} />
        </div>
      ),
    },
    {
      type: "review-node-start",
      name: "review-node-start",
      displayComponent: ReviewTaskNodeDisplay,
      // configComponent: ApprovalConfigForm,
      actionType: "review-node-start",
      customRemove: true,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <img src={reviewIcon} />
          {/* <AllInclusive style={{ color: "#9f64ff" }} /> */}
        </div>
      ),
    },

    {
      type: "review",
      name: "review",
      conditionNodeType: "review-node",
      actionType: "review",
      addConditionIcon: null,
      configComponent: null,
      conditionMaxNum: 1,
      className: "review-parent",
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <img src={reviewIcon} />
          {/* <AllInclusive style={{ color: "#9f64ff" }} /> */}
        </div>
      ),
    },

    {
      type: "review-node",
      name: "review-node",
      displayComponent: ReviewTaskNodeDisplay,
      actionType: "review-node",
      customRemove: true,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <img src={reviewIcon} />
          {/* <AllInclusive style={{ color: "#9f64ff" }} /> */}
        </div>
      ),
    },

    {
      type: "READ_CREDENTIALS",
      name: "Read Credentials",
      actionType: "READ_CREDENTIALS",
      displayComponent: ReadCredentialsNode,
      // configComponent: ConfigReadCredentials,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
        >
          <img style={{ width: "12px" }} src={readCredIcon} />
        </div>
      ),
    },
    {
      type: "READ_TABLE",
      name: "Read Table",
      actionType: "READ_TABLE",
      displayComponent: ReadTableNodeDisplay,
      // configComponent: ReadTableConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
        >
          <img src={readTableIcon} />
        </div>
      ),
    },
    {
      type: "record",
      name: "show",
      actionType: "record",
      displayComponent: NodeDisplay,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff3ea", borderColor: "#ff7007" }}
        >
          <img src={recordIcon} />
        </div>
      ),
    },
    {
      type: "httpapi",
      name: "Service Call",
      actionType: "httpapi",
      displayComponent: HttpApiNodeDisplay,
      // configComponent: HttpApiConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#ffe5fe", borderColor: "#ff07f5" }}
        >
          <img src={httpApi} />
        </div>
      ),
    },
    {
      type: "stop",
      name: "stop",
      displayComponent: StopNodeDisplay,
      actionType: "stop",
      configComponent: null,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
        >
          <img src={stopIcon} />
        </div>
      ),
    },
    {
      type: "supervityOcr",
      name: "Supervity OCR",
      actionType: "httpapi",
      displayComponent: SupervityOCRNodeDisplay,
      // configComponent: SupervityOCRConfigPanel,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
        >
          <img
            src={dataExtactionIcon}
            style={{ width: "12px", maxWidth: "initial" }}
          />
        </div>
      ),
    },
    {
      type: "SWITCHAPP",
      name: "Switch App",
      actionType: "SWITCHAPP",
      displayComponent: SwitchAppNodeDisplay,
      // configComponent: SwitchAppConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
          //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={switchAppIcon} style={{ width: "12px" }} />
        </div>
      ),
    },
    // {
    //   type: "SMTP",
    //   name: "SMTP Send Mail",
    //   actionType: "SMTP",
    //   displayComponent: AddSMTPNode,
    //   // configComponent: SMTPSendMailConfigForm,
    //   addIcon: (
    //     <div
    //       className="stepIconBlock"
    //       style={{ padding: "0px", borderRadius: "0px", border: "none" }}
    //     >
    //       <img src={smtpIcon} />
    //     </div>
    //   ),
    // },
    {
      type: "S3_CONNECT",
      name: "S3 Connect",
      actionType: "S3_CONNECT",
      displayComponent: AddS3Node,
      // configComponent: ConfigS3,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: " #ffe3ce", borderColor: "#ff7007" }}
        >
          <img src={s3ConnectIcon} />
        </div>
      ),
    },
    {
      type: "S3_FILE_ARCHIVE",
      name: "S3 File Archive",
      actionType: "S3_FILE_ARCHIVE",
      displayComponent: AddS3ArchiveNode,
      // configComponent: ConfigS3Archive,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: " #ffe3ce", borderColor: " #173bff" }}
        >
          <img src={s3ArchiveIcon} />
        </div>
      ),
    },

    {
      type: "S3_FILE_DOWNLOAD",
      name: "S3 File Download",
      actionType: "S3_FILE_DOWNLOAD",
      displayComponent: AddS3DownloadNode,
      // configComponent: ConfigS3Download,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#ebebeb", borderColor: "#1d262e" }}
        >
          <img style={{ width: "12px" }} src={s3FileDownloadIcon} />
        </div>
      ),
    },

    {
      type: "SCREENSHOT",
      name: "Screenshot",
      actionType: "SCREENSHOT",
      displayComponent: ScreenshotNodeDisplay,
      // configComponent: ConfigScreenshot,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#ebebeb", borderColor: "#1d262e" }}
        >
          <img style={{ width: "12px" }} src={screenShotIcon} />
        </div>
      ),
    },
    {
      type: "GET_AZURESECRET",
      name: "Get Secret",
      actionType: "GET_AZURESECRET",
      displayComponent: SecretNodeDisplay,
      configComponent: null,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
        >
          <img src={assign} />
        </div>
      ),
    },
    {
      type: "try",
      name: "try",
      conditionNodeType: "try-catch-node",
      actionType: "try",
      addConditionIcon: null,
      configComponent: null,
      conditionMaxNum: 1,
      customRemove: false,
      className: "try-catch-parent try-catch-parent-verbose",
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <AllInclusive style={{ color: "#9f64ff" }} />
        </div>
      ),
    },

    {
      type: "try-catch-node",
      name: "try-catch-node",
      className: "try-catch-node try-catch-node-verbose",
      displayComponent: TryCatchDisplay,
      actionType: "try-catch-node",
      customRemove: true,
      configComponent: null,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
        >
          <AllInclusive style={{ color: "#9f64ff" }} />
        </div>
      ),
    },
    {
      type: "condition",
      name: "condition",
      actionType: "condition",
      displayComponent: ConditionNodeDisplay,
      // configComponent: ConfigPanel,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      configTitle: "Configure Condition",
    },
    {
      type: "wait",
      name: "wait",
      actionType: "wait",
      displayComponent: DelayNodeDisplay,
      configComponent: null,
      addIcon: (
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
        >
          <img src={waitIcon} />
        </div>
      ),
    },
    {
      type: "XML_TO_JSON",
      name: "XML to JSON",
      actionType: "XML_TO_JSON",
      displayComponent: XmlToJsonNodeDisplay,
      // configComponent: XmlToJsonConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          // style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={xmlIcon} />
        </div>
      ),
    },
    {
      type: "THROW",
      name: "Throw Error",
      actionType: "THROW",
      displayComponent: ThrowNodeDisplay,
      // configComponent: ThrowConfig,
      addIcon: (
        <div
          className="stepIconBlock"
          // style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
          style={{ padding: "0px", borderRadius: "0px", border: "none" }}
        >
          <img src={ThrowAction_Icon} />
        </div>
      ),
    },
  ];

  const handleChange = (_nodes, e) => {
    let diff = {};
    switch (e) {
      case "init-builder":
        setNodes(_nodes);
        break;
      case "click-node":
      case "close-drawer":
        break;

      default:
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
    }
  };

  return (
    <>
      <FlowBuilder
        className={`crt-tpl-flow outer-drag scrollable ${customClassName}`}
        nodes={nodes}
        onChange={handleChange}
        registerNodes={registerNodes}
        // zoomTool
        backgroundColor={"#F2F5F6"}
        readonly={true}
      />

      {/* Step Info Modal */}

      <Drawer
        title="Preview"
        placement="right"
        width={400}
        visible={showPanel}
        onClose={() => handleCancel()}
      >
        {showPanel ? (
          <>
            {" "}
            <div className="compare-data">
              <table className="table table-sm table-striped table-bordered">
                <tbody>
                  {Object.entries(currentNode).map(([key, value]) =>
                    typeof value == "string" && value !== "" ? (
                      <tr className="object-detail" key={key}>
                        <td>
                          <span className="stepkey">{key}:</span>
                          <span className="stepvalue">{value}</span>
                        </td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </table>
            </div>
          </>
        ) : null}
      </Drawer>
    </>
  );
};

export default DisplayFlowNodes;
